import React from 'react';
import { Redirect } from 'react-router-dom';
import urls from 'Source/urls';
import { useAIEnabledWithLoading } from 'Hooks/useAIEnabled';
import FallbackLoadingV3 from 'Components/FallbackLoading/FallbackLoadingV3';

// Decides the post-login landing page: users with AI access land on the AI
// chat; everyone else keeps the historical Overview destination. Rendered as a
// component (not a <Redirect>) so we can hold off on a decision until the
// `pantherAIEnabled` query resolves — otherwise AI users would briefly see
// Overview on every fresh login.
//
// Gated additionally by the `AILandingPage` split flag — a tenant with AI
// otherwise enabled stays on Overview until the flag is flipped on.
const LandingRedirectV3: React.FC = () => {
  const { enabled, loading } = useAIEnabledWithLoading(['ENABLE_AI_LANDING_PAGE']);
  if (loading) {
    return <FallbackLoadingV3 />;
  }
  return <Redirect to={enabled ? urls.ai.home() : urls.dashboard.overview()} />;
};

export default LandingRedirectV3;
